import { Directive, ElementRef, inject, input } from '@angular/core';

/**
 * Table row directive
 *
 * @example
 *   ```html
 *   <hx-table-row *ngFor="let item of data">
 *     <hx-table-cell>{{item.name}}</hx-table-cell>
 *   </hx-table-row>
 *   ```;
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'hx-table-row',
  standalone: true,
  host: {
    class: 'hx-table-row',
    role: 'row',
    '[class.hx-table-row--selected]': 'selected()',
    '[style.background-color]': 'backgroundColor()',
    '[style.color]': 'color()',
    '[style.border-color]': 'borderColor()',
  },
})
export class HxTableRowDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  /** Whether row is selected */
  readonly selected = input<boolean>(false);

  /** Custom background color */
  readonly backgroundColor = input<string>();

  /** Custom text color */
  readonly color = input<string>();

  /** Custom border color */
  readonly borderColor = input<string>();
}
